import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./lib/auth";
import PublicLayout from "./layouts/PublicLayout";
import AdminLayout from "./layouts/AdminLayout";

import Home from "./pages/Home";
import Rentals from "./pages/Rentals";
import Transfers from "./pages/Transfers";
import Tours from "./pages/Tours";
import TourDetail from "./pages/TourDetail";
import LongTerm from "./pages/LongTerm";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import RefundPolicy from "./pages/RefundPolicy";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminVehicles from "./pages/admin/AdminVehicles";
import AdminBookings from "./pages/admin/AdminBookings";
import AdminCalendar from "./pages/admin/AdminCalendar";
import AdminInquiries from "./pages/admin/AdminInquiries";
import AdminEmailSettings from "./pages/admin/AdminEmailSettings";
import AdminTransferLocations from "./pages/admin/AdminTransferLocations";
import AdminTransferRoutePrices from "./pages/admin/AdminTransferRoutePrices";
import AdminDrivers from "./pages/admin/AdminDrivers";
import AdminTours from "./pages/admin/AdminTours";
import AdminTransportPricing from "./pages/admin/AdminTransportPricing";
import AdminBookingCreate from "./pages/admin/AdminBookingCreate";
import AdminBookingDetail from "./pages/admin/AdminBookingDetail";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import DriverLogin from "./pages/driver/DriverLogin";
import DriverSetPassword from "./pages/driver/DriverSetPassword";
import DriverDashboard from "./pages/driver/DriverDashboard";
import DriverJobDetail from "./pages/driver/DriverJobDetail";
import DriverIssuePage from "./pages/driver/DriverIssuePage";
import AdminDispatch from "./pages/admin/AdminDispatch";
import AdminVehicleIssues from "./pages/admin/AdminVehicleIssues";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/rentals" element={<Rentals />} />
              <Route path="/transfers" element={<Transfers />} />
              <Route path="/tours" element={<Tours />} />
            <Route path="/tours/:slug" element={<TourDetail />} />
              <Route path="/long-term" element={<LongTerm />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/driver/login" element={<DriverLogin />} />
            <Route path="/driver/set-password" element={<DriverSetPassword />} />
            <Route path="/driver" element={<DriverDashboard />} />
            <Route path="/driver/job/:jobId" element={<DriverJobDetail />} />
            <Route path="/driver/report" element={<DriverIssuePage />} />
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/vehicles" element={<AdminVehicles />} />
              <Route path="/admin/bookings" element={<AdminBookings />} />
              <Route path="/admin/bookings/new" element={<AdminBookingCreate />} />
              <Route path="/admin/bookings/:bookingId" element={<AdminBookingDetail />} />
              <Route path="/admin/calendar" element={<AdminCalendar />} />
              <Route path="/admin/inquiries" element={<AdminInquiries />} />
              <Route path="/admin/transfer-locations" element={<AdminTransferLocations />} />
              <Route path="/admin/transfer-route-prices" element={<AdminTransferRoutePrices />} />
              <Route path="/admin/transport-pricing" element={<AdminTransportPricing />} />
              <Route path="/admin/drivers" element={<AdminDrivers />} />
              <Route path="/admin/dispatch" element={<AdminDispatch />} />
              <Route path="/admin/vehicle-issues" element={<AdminVehicleIssues />} />
              <Route path="/admin/tours" element={<AdminTours />} />
              <Route path="/admin/email-settings" element={<AdminEmailSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
